import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RestContractorModel } from '@shared/interfaces/contractors.interface';

@Injectable({
  providedIn: 'root',
})
export class ContractorsService {
  constructor(private restApiService: RestapiService) {}

  getUnassignedContractorsList(): Observable<RestContractorModel[]> {
    return this.restApiService.getData<RestContractorModel[]>(`Contractors/unassigned`);
  }
}
